import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row, Col } from 'antd';
import Head from '../../utils/head';
import Edit from '../../utils/edit';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';

const FormItem = Form.Item;
import { connect } from 'react-redux';

let getUserAngentsUrl = Urls.UserAngentsUrl.list;
let modify = Urls.UserAngentsUrl.modify;
let find = Urls.UserAngentsUrl.selectById;

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10,
            },
        };
        this.onChange = this.onChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
    }
    componentWillMount() {
        this.getList(getUserAngentsUrl + paramsEncode(this.state.serach));
        //select options
        if (sessionStorage.getItem('ua.options')) {
            return;
        }
        (async url => {
            try {
                let response = await request(url);
                sessionStorage.setItem('ua.options', JSON.stringify(response));
                //this.setState(Object.assign(this.state))
            } catch (e) {
                console.log(e);
                message.error('初始化参数失败');
            }
        })(Urls.UserAngentsUrl.paramList);
    }

    async getList(url) {
        let response = await request(url);
        this.setState(Object.assign(this.state, response)); //total,list
    }

    async confirm(record) {
        let url = Urls.UserAngentsUrl.delete;
        try {
            let response = await request(url, 'delete', record);
            message.success('删除成功');
            this.handleRefresh(); //删除完成重新刷新网页
        } catch (e) {
            console.log(e);
            message.error('删除失败');
        }
    }

    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getUserAngentsUrl + paramsEncode(this.state.serach));
    }

    serach(serach) {
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach, { page: 1 }); //page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async url => {
            try {
                let response = await request(url);
                this.state.list = response.list;
                this.setState(Object.assign(this.state, response));
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(getUserAngentsUrl + paramsEncode(this.state.serach));
    }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach, { page: 1 });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getUserAngentsUrl + paramsEncode(this.state.serach));
    }

    render() {
        let jsonUaOptions = sessionStorage.getItem('ua.options');
        let uaOptions = jsonUaOptions ? JSON.parse(jsonUaOptions) : { deviceInfo: [], browser: [] };
        let metadata = [];
        let addMetas = [
            {
                type: 'Select',
                placeholder: '请选择平台',
                label: '平台',
                field: 'platform',
                isRequired: true,
                options: ['APP', 'PC'],
            },
            {
                type: 'Select',
                placeholder: '请选择设备',
                label: '设备',
                isRequired: true,
                field: 'deviceInfo',
                options: uaOptions.deviceInfo,
            },
            {
                type: 'Select',
                placeholder: '请选择浏览器',
                label: '浏览器',
                isRequired: true,
                field: 'browser',
                options: uaOptions.browser,
            },
            ,
            {
                type: 'Input',
                placeholder: 'UA',
                label: 'UA',
                isRequired: true,
                field: 'userAgent',
            },
        ];
        const columns = [
            {
                title: '浏览器',
                dataIndex: 'browser',
                key: 'browser',
            },
            {
                title: '平台',
                dataIndex: 'platform',
                key: 'platform',
            },
            {
                title: '设备',
                dataIndex: 'deviceInfo',
                key: 'deviceInfo',
            },
            {
                title: 'UA',
                dataIndex: 'userAgent',
                width: 900,
                key: 'userAgent',
            },
            {
                title: '操作',
                key: 'action',
                render: record => (
                    <span>
                        <Edit
                            metadata={addMetas}
                            url={modify}
                            find={find + '' + record._id}
                            handleRefresh={this.handleRefresh}
                        />
                        <span className="ant-divider" />
                        <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                            <a href="#">删除</a>
                        </Popconfirm>
                    </span>
                ),
            },
        ];
        return (
            <div className="1111">
                <Row className="searchRow">
                    <Col span={4}>
                        <h2>UA信息</h2>
                    </Col>
                    <Col span={20} style={{ textAlign: 'right' }}>
                        <Head
                            serachMeta={metadata}
                            addMeta={addMetas}
                            addUrl={modify}
                            handleRefresh={this.handleRefresh}
                        />
                    </Col>
                </Row>

                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered />
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={this.state.serach.page}
                    total={this.state.total}
                    className="ant-table-pagination"
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/sider/user-angent.js